import { Loader2, Save } from "lucide-react";
import { Button } from "@/components/ui/button";
import RichText from "@/components/RichText";

export const ConditionsEditorPanel = ({ terms, setTerms, onSave, saving }) => (
  <section className="border-t border-[#E5E5E0] pt-8 pb-12" data-testid="conditions-section">
    <div className="flex flex-wrap items-center justify-between gap-4 mb-5">
      <h2 className="font-serif text-2xl">Condizioni di utilizzo</h2>
      <Button type="button" onClick={onSave} disabled={!!saving} data-testid="conditions-save-button">
        {saving === "terms" ? <Loader2 className="animate-spin" /> : <Save />}
        Salva condizioni
      </Button>
    </div>
    <RichText value={terms} onChange={setTerms} minHeight={240} testId="terms-editor" allowTypography viewportHeight />
  </section>
);